import { SaveBloccoModel } from "./saveBlocco.model";
export class BloccoModel extends SaveBloccoModel {
  cols?: number;

  idBloccoSlider: number;
  idBlocco: number;
  token: string;
  ordine: number;
  authManItems?: Array<any>;
  businessLines?: Array<any>;
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/models/dashboard/blocco.model.ts